import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { Consultation } from '../models/consultation.model';
import { Activity } from '../models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class ConsultationService {
  private apiUrl = environment.apiUrl + '/Consultation';

  http = inject(HttpClient);

  saveConsultation(consultation: Consultation): Observable<Activity> {
    return this.http.post<Activity>(
      `${this.apiUrl}/CreateConsultation`,
      consultation
    );
  }

  updateConsultation(consultation: Consultation): Observable<Activity> {
    return this.http.put<Activity>(
      `${this.apiUrl}/UpdateConsultation/${consultation.consultationId}`,
      consultation
    );
  }
}
